module.exports = __webpack_public_path__ + "static/Sport_Spiel-0f45968aeae71841b10d4922a412b6f4.png";